/* eslint-disable class-methods-use-this */
import { Result, ExportsBulk } from '@odiupsk/up-api-client'
import { i18n } from '../utils/intl'
import { downloadBlob } from '../utils/downloadToDisk'
import { maxPerPage } from '../utils/maxPerPage'
import { logSuccess, logError } from './utils'
import { cardsApi } from '.'

export class ApiCardsRepository {
  static async deactivateCard(cardId: string) {
    try {
      const res = await cardsApi.postCardDeactivate(cardId)
      logSuccess(i18n.t`Karta bola úspešne deaktivovaná.`)
      return res.data
    } catch (err) {
      logError(err, i18n.t`Pri deaktivácii karty nastala chyba.`)
      throw err
    }
  }

  static async activateCard(cardId: string) {
    try {
      const res = await cardsApi.postCardActivate(cardId)
      logSuccess(i18n.t`Karta bola úspešne aktivovaná.`)
      return res.data
    } catch (err) {
      logError(err, i18n.t`Pri aktivácii karty nastala chyba.`)
      throw err
    }
  }

  static async blockCard(cardId: string) {
    try {
      const res = await cardsApi.postCardBlocation(cardId)
      logSuccess(i18n.t`Požiadavka na zablokovanie karty bola odoslaná.`)
      return res.data
    } catch (err) {
      logError(err, i18n.t`Pro požiadavke na zablokovanie karty nastala chyba.`)
      throw err
    }
  }

  static async fetchHistoryRequirements(id: string) {
    try {
      const res = await cardsApi.getHistoryRequirements(id, {
        params: { per_page: maxPerPage },
      })
      return res.data
    } catch (err) {
      logError(err)
      throw err
    }
  }

  static async fetchHistoryStates(id: string) {
    try {
      const res = await cardsApi.getHistoryStates(id, {
        params: { per_page: maxPerPage },
      })
      return res.data
    } catch (err) {
      logError(err)
      throw err
    }
  }

  static async replaceCard(cardId: string) {
    try {
      const res = await cardsApi.postCardReplacement(cardId)
      logSuccess(i18n.t`Požiadavka bola úspešne odoslaná`)
      return res.data
    } catch (err) {
      logError(err, i18n.t`Pri odosielaní požiadavky nastala chyba.`)
      throw err
    }
  }

  static async printPinForCard(cardId: string) {
    try {
      const res = await cardsApi.postCardLostPin(cardId)
      logSuccess(i18n.t`Požiadavka bola úspešne odoslaná`)
      return res.data
    } catch (err) {
      logError(err, i18n.t`Pri odosielaní požiadavky nastala chyba.`)
      throw err
    }
  }

  static async changeAutoRenewCard(cardId: string, autoRenew: boolean) {
    try {
      const res = await cardsApi.api.post<Result>(`/cards/${cardId}/auto_renew`, null, {
        params: { value: autoRenew },
      })
      // FIXME: api
      // postAutoRenew(cardId, {
      //   params: { value: autoRenew },
      // })
      logSuccess(i18n.t`Operácia bola úspešná`)
      return res.data
    } catch (err) {
      logError(err, i18n.t`Pri operácii nastala chyba.`)
      throw err
    }
  }

  static async changeAutoRenewAllCards(clientId: string, autoRenew: boolean) {
    try {
      const res = await cardsApi.api.post<Result>(
        `/clients/${clientId}/auto_renew_all_cards`,
        null,
        {
          params: { value: autoRenew },
        }
      )
      logSuccess(i18n.t`Operácia bola úspešná`)
      return res.data
    } catch (err) {
      logError(err, i18n.t`Pri operácii nastala chyba.`)
      throw err
    }
  }

  static async postCardsBulk(ids: string[], operation: number) {
    try {
      const res = await cardsApi.postCardsBulk({
        operation,
        ids,
      })
      logSuccess(res.data.messages?.[0].message || i18n.t`Operácia bola úspešná`)
      return res.data
    } catch (err) {
      logError(err, i18n.t`Pri operácii nastala chyba.`)
      throw err
    }
  }

  static async postCardCreditMemo(cardId: string, dischargeWholeAccount: boolean, value: number) {
    try {
      await cardsApi.postCardCreditMemo(cardId, {
        discharge_whole_account: dischargeWholeAccount,
        value,
      })

      logSuccess(i18n.t`Dobropis prostriedkov prebehol úspešne`)
    } catch (err) {
      logError(err, i18n.t`Dobropis prostriedkov neprebehol úspešne.`)
      throw err
    }
  }

  static async postCreditNotesExport(clientId: string, body: ExportsBulk) {
    try {
      const res = await cardsApi.postCreditNotesExport(clientId, body, {
        responseType: 'blob',
      })
      downloadBlob(res as any)
      return res.data
    } catch (err) {
      logError(err, i18n.t`Pri operácii nastala chyba.`)
      throw err
    }
  }

  static async postCreditNotesImport(clientId: string, body: File) {
    try {
      const res = await cardsApi.postCreditNotesImport(clientId, body)
      return res.data
    } catch (err) {
      logError(err, i18n.t`Pri operácii nastala chyba.`)
      throw err
    }
  }
}
